import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../CallWidget.css';

const DemoRequestForm = ({ onClose }) => {
  const [formState, handleFormSubmit] = useForm("mzzkayvz"); // Using same form as feedback for now
  
  if (formState.succeeded) {
    return (
      <div className="call-widget">
        <div className="call-header-bar">
          <div className="header-left">
            <span className="header-title-bar">Thank You!</span>
          </div>
          <div className="header-right">
            <button className="rect-btn-header" onClick={onClose}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
              Close
            </button>
          </div>
        </div>
        
        <div className="call-widget-content">
          <div className="transcript-panel" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '400px' }}>
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{ marginBottom: '24px' }}>
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" style={{ width: '64px', height: '64px', margin: '0 auto', color: '#10b981' }}>
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '12px', color: '#1f2937' }}>Request Received!</h3>
              <p style={{ fontSize: '16px', color: '#6b7280', maxWidth: '400px', margin: '0 auto' }}>
                We'll get back to you shortly with your personalized AI voice assistant demo.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="call-widget">
      <div className="call-header-bar">
        <div className="header-left">
          <span className="header-title-bar">Request Demo</span>
        </div>
        <div className="header-right">
          <button className="rect-btn-header" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Close
          </button>
        </div>
      </div>
      
      <div className="call-widget-content">
        <div className="transcript-panel" style={{ padding: '32px', overflowY: 'auto', maxHeight: '600px' }}>
          <div style={{ maxWidth: '500px', margin: '0 auto' }}>
            <div style={{ marginBottom: '24px', textAlign: 'center' }}>
              <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px', color: '#1f2937' }}>
                Get Your Own Live Demo
              </h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>
                Fill out the form below and we'll set up a personalized AI voice assistant for your practice
              </p>
            </div>
            
            <form onSubmit={handleFormSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div>
                <label htmlFor="name" style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '6px', color: '#374151' }}>
                  Name *
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  required
                  placeholder="Your full name"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                />
                <ValidationError prefix="Name" field="name" errors={formState.errors} />
              </div>
              
              <div>
                <label htmlFor="email" style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '6px', color: '#374151' }}>
                  Email *
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  placeholder="your@email.com"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                />
                <ValidationError prefix="Email" field="email" errors={formState.errors} />
              </div>
              
              <div>
                <label htmlFor="website" style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '6px', color: '#374151' }}>
                  Website *
                </label>
                <input
                  id="website"
                  type="text"
                  name="website"
                  required
                  placeholder="yourpractice.com"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                />
                <ValidationError prefix="Website" field="website" errors={formState.errors} />
              </div>
              
              <div>
                <label htmlFor="message" style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '6px', color: '#374151' }}>
                  Additional Information (Optional)
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="3"
                  placeholder="Tell us about your practice and what you're looking for..."
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    resize: 'vertical',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                />
                <ValidationError prefix="Message" field="message" errors={formState.errors} />
              </div>
              
              <button
                type="submit"
                disabled={formState.submitting}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: formState.submitting ? '#9ca3af' : '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: formState.submitting ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => !formState.submitting && (e.target.style.background = '#2563eb')}
                onMouseLeave={(e) => !formState.submitting && (e.target.style.background = '#3b82f6')}
              >
                {formState.submitting ? 'Submitting...' : 'Request Demo'}
              </button>
            </form>
            
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <p style={{ fontSize: '12px', color: '#9ca3af' }}>
                Powered by The Reasoning Company
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoRequestForm;
